import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';

import BoxscoreTab from '@/components/Tabs/Boxscore';
import TeamBoxscore from '@/components/TeamBoxscore';

function Boxscore({ teams, ...props }) {
  const [teamBoxscore, setTeamBoxscore] = useState('visitor');
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BoxscoreTab onChange={setTeamBoxscore} value={teamBoxscore} teams={teams} />
      </Grid>
      <Grid item xs={12}>
        <TeamBoxscore
          team={teams[teamBoxscore]}
          {...props}
        />
      </Grid>
    </Grid>
  )
}

export default Boxscore;
